import { CHANNEL_DEFAULT, PRODUCT_NAME } from "../constants";
import { RANGE_OF_EMPLOYEES } from "../../../constants/enums/range-of-employees";

export type PhaseOneParameters = {
    channel?: string;
    ruc: string;
    name?: string;
    lastName: string;
    phone: string;
    email: string;
    amount: number;
    range: typeof RANGE_OF_EMPLOYEES;
    annualPrice: number;
    semesterPrice: number;
    from: string;
    partyId?: number;
};

export class PhaseOne {
    fase: string;
    canal: string;
    producto: string;
    ruc: string;
    nombre: string;
    apellido: string;
    celular: string;
    email: string;
    monto: number;
    rango: typeof RANGE_OF_EMPLOYEES;
    precioAnual: number;
    precioSemestral: number;
    from: string;

    constructor({
        channel,
        ruc,
        name,
        lastName,
        phone,
        email,
        amount,
        range,
        annualPrice,
        semesterPrice,
        from,
    }: PhaseOneParameters) {
        // this.fase = "precotización";
        this.fase = "precotizacion";
        this.canal = channel || CHANNEL_DEFAULT;
        this.producto = PRODUCT_NAME;
        this.ruc = ruc;
        this.nombre = name || "";
        this.apellido = lastName;
        this.celular = phone;
        this.email = email;
        this.monto = amount;
        this.rango = range;
        this.precioAnual = Number.parseFloat(annualPrice.toFixed(2));
        this.precioSemestral = Number.parseFloat(semesterPrice.toFixed(2));
        this.from = from;
    }
}
